export default "__VITE_ASSET__88610ce4__"